// Generated by Melange

import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../components/molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../components/html/Checkbox.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Date from "../../util/Date.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__PayrollHrm from "../../grpc/PayrollHrm.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_cabinet__RadioButton from "../../components/html/RadioButton.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__TaxControl from "../../grpc/TaxControl.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_cabinet__Toggle from "../../components/atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function HrmEmployeeFormPage(Props) {
  let org = Props.org;
  let idOpt = Props.id;
  let openMenu = Props.openMenu;
  const id = idOpt !== undefined ? idOpt : "";
  const match = React.useState(function () {
    return "";
  });
  const setBirthday = match[1];
  const birthday = match[0];
  const match$1 = React.useState(function () {
    return "";
  });
  const setIin = match$1[1];
  const iin = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setLastname = match$2[1];
  const lastname = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setName = match$3[1];
  const name = match$3[0];
  const match$4 = React.useState(function () {
    return "";
  });
  const setPatronymicName = match$4[1];
  const patronymicName = match$4[0];
  const match$5 = React.useState(function () {
    return "";
  });
  const setPosition = match$5[1];
  const position = match$5[0];
  const match$6 = React.useState(function () {
    return false;
  });
  const setShowEmployeeData = match$6[1];
  const showEmployeeData = match$6[0];
  const match$7 = React.useState(function () {
    return "";
  });
  const setPhoneNumber = match$7[1];
  const phoneNumber = match$7[0];
  const match$8 = React.useState(function () {
    return "";
  });
  const setEmail = match$8[1];
  const email = match$8[0];
  const match$9 = React.useState(function () {
    return "";
  });
  const setAddress = match$9[1];
  const address = match$9[0];
  const match$10 = React.useState(function () {
    return "";
  });
  const setJobStartDate = match$10[1];
  const jobStartDate = match$10[0];
  const match$11 = React.useState(function () {
    return "option1";
  });
  const empTypeSelectedOption = match$11[0];
  const match$12 = React.useState(function () {
    return "option1";
  });
  const setPaymentTypeOption = match$12[1];
  const paymentTypeOption = match$12[0];
  const match$13 = React.useState(function () {
    return "";
  });
  const setSalary = match$13[1];
  const salary = match$13[0];
  const match$14 = React.useState(function () {
    return false;
  });
  const setIsStandardTaxes = match$14[1];
  const isStandardTaxes = match$14[0];
  const match$15 = React.useState(function () {
    return "";
  });
  const setTaxesStartDate = match$15[1];
  const taxesStartDate = match$15[0];
  const match$16 = React.useState(function () {
    return true;
  });
  const grossMethod = match$16[0];
  const match$17 = React.useState(function () {
    return true;
  });
  const setResident = match$17[1];
  const resident = match$17[0];
  const match$18 = React.useState(function () {
    return true;
  });
  const setEResident = match$18[1];
  const eResident = match$18[0];
  const match$19 = React.useState(function () {
    return true;
  });
  const setResidentPermit = match$19[1];
  const residentPermit = match$19[0];
  const match$20 = React.useState(function () {
    return /* EMPLOYMENT_TYPE_UNSPECIFIED */ 0;
  });
  const setEmploymentType = match$20[1];
  const employmentType = match$20[0];
  const match$21 = React.useState(function () {
    return false;
  });
  const setIsBenefit = match$21[1];
  const isBenefit = match$21[0];
  const match$22 = React.useState(function () {
    return false;
  });
  const setIsRetired = match$22[1];
  const isRetired = match$22[0];
  const match$23 = React.useState(function () {
    return "";
  });
  const setRetiredStartDate = match$23[1];
  const retiredStartDate = match$23[0];
  const match$24 = React.useState(function () {
    return false;
  });
  const setIsRetiredByYearsServed = match$24[1];
  const isRetiredByYearsServed = match$24[0];
  const match$25 = React.useState(function () {
    return "";
  });
  const retiredDutyStartDate = match$25[0];
  const match$26 = React.useState(function () {
    return false;
  });
  const setIsDisabled = match$26[1];
  const isDisabled = match$26[0];
  const match$27 = React.useState(function () {
    return "";
  });
  const setDisabledStartDate = match$27[1];
  const disabledStartDate = match$27[0];
  const match$28 = React.useState(function () {
    return /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  });
  const disabledCategory = match$28[0];
  const match$29 = React.useState(function () {
    return "";
  });
  const setDisabledEndDate = match$29[1];
  const disabledEndDate = match$29[0];
  const match$30 = React.useState(function () {
    return /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  });
  const disabledPermanentCategory = match$30[0];
  const match$31 = React.useState(function () {
    return false;
  });
  const setIsDisabledIndefinitely = match$31[1];
  const isDisabledIndefinitely = match$31[0];
  const match$32 = React.useState(function () {
    return "";
  });
  const disabledIndefinitelyStartDate = match$32[0];
  const match$33 = React.useState(function () {
    return "";
  });
  const setBenefitStartDate = match$33[1];
  const match$34 = React.useState(function () {
    return false;
  });
  const setIsParent = match$34[1];
  const isParent = match$34[0];
  const match$35 = React.useState(function () {
    return "";
  });
  const parentBenefitStartDate = match$35[0];
  const match$36 = React.useState(function () {
    return "";
  });
  const setParentStartDate = match$36[1];
  const match$37 = React.useState(function () {
    return 0;
  });
  const setChildren = match$37[1];
  const children = match$37[0];
  const match$38 = React.useState(function () {
    return false;
  });
  const setIsMother = match$38[1];
  const isMother = match$38[0];
  const match$39 = React.useState(function () {
    return "";
  });
  const setMotherBenefitStartDate = match$39[1];
  const motherBenefitStartDate = match$39[0];
  const match$40 = React.useState(function () {
    return false;
  });
  const setIsStudent = match$40[1];
  const isStudent = match$40[0];
  const match$41 = React.useState(function () {
    return "";
  });
  const setStudentBenefitStartDate = match$41[1];
  const studentBenefitStartDate = match$41[0];
  const match$42 = React.useState(function () {
    return "";
  });
  const setStudentBenefitEndDate = match$42[1];
  const studentBenefitEndDate = match$42[0];
  const match$43 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$43[0];
  const match$44 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$44[1];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Hrm */ 5,
      _0: {
        TAG: /* Employees */ 0,
        _0: /* Index */ 0
      }
    }),
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/back-arrow.svg")
    })
  });
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: "Новый сотрудник",
      leftChildren: backButton,
      openMenu: openMenu
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: id === "" ? "Новый сотрудник" : "Редактировать сотрудника",
      route: contextRoute({
        TAG: /* Hrm */ 5,
        _0: {
          TAG: /* Employees */ 0,
          _0: /* Index */ 0
        }
      })
    });
  let disabledCategory$1;
  switch (disabledCategory) {
    case /* PERSON_CATEGORY_DISABLED_GROUP_1 */ 3 :
    case /* PERSON_CATEGORY_DISABLED_GROUP_2 */ 5 :
    case /* PERSON_CATEGORY_DISABLED_GROUP_3 */ 7 :
      disabledCategory$1 = disabledCategory;
      break;
    default:
      disabledCategory$1 = /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  }
  let disabled_category_permanent;
  switch (disabledPermanentCategory) {
    case /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */ 4 :
    case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */ 6 :
      disabled_category_permanent = disabledPermanentCategory;
      break;
    default:
      disabled_category_permanent = /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  }
  const func = Buhta_cabinet__PayrollHrm.EmployeeService.view;
  const match$45 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$45[1];
  const employee = match$45[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  React.useEffect((function () {
    if (typeof employee !== "string" && employee.NAME === "Data") {
      const prop = employee.VAL;
      const date = prop.birthday_date;
      const birthday_date = date !== undefined ? Buhta_cabinet__Date.toString(date) : "";
      const address = prop.address;
      const address$1 = address !== undefined ? address : "";
      Curry._1(setIin, (function (param) {
        return prop.tin;
      }));
      Curry._1(setName, (function (param) {
        return prop.given_name;
      }));
      Curry._1(setLastname, (function (param) {
        return prop.family_name;
      }));
      Curry._1(setPatronymicName, (function (param) {
        return prop.patronymic_name;
      }));
      Curry._1(setBirthday, (function (param) {
        return birthday_date;
      }));
      Curry._1(setAddress, (function (param) {
        return address$1;
      }));
      Curry._1(setPhoneNumber, (function (param) {
        return prop.phone;
      }));
      Curry._1(setEmail, (function (param) {
        return prop.email;
      }));
    }
    
  }), [employee]);
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsxs("form", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                label: "ИИН",
                type_: "text",
                name: "iin",
                size: "m",
                required: true,
                onChange: (function (value) {
                  Curry._1(setIin, (function (param) {
                    return value;
                  }));
                }),
                value: iin
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Фамилия",
                    type_: "text",
                    name: "lastname",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      Curry._1(setLastname, (function (param) {
                        return value;
                      }));
                    }),
                    value: lastname
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Имя",
                    type_: "text",
                    name: "name",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      Curry._1(setName, (function (param) {
                        return value;
                      }));
                    }),
                    value: name
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Отчество",
                    type_: "text",
                    name: "patronymicName",
                    size: "m",
                    required: false,
                    onChange: (function (value) {
                      Curry._1(setPatronymicName, (function (param) {
                        return value;
                      }));
                    }),
                    value: patronymicName
                  })
                ],
                className: "flex flex-col md:flex-row gap-4 mt-4"
              }),
              JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                value: birthday,
                onPicked: (function (date) {
                  Curry._1(setBirthday, (function (param) {
                    return DateTime.toDateFormat(date);
                  }));
                }),
                align: "BottomRight",
                className: "w-full mt-4",
                label: "Дата рождения",
                isBirthDay: true
              }),
              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                label: "Адрес",
                type_: "address",
                name: "address",
                size: "m",
                onChange: (function (value) {
                  Curry._1(setAddress, (function (param) {
                    return value;
                  }));
                }),
                multiline: true,
                className: "w-full mt-4",
                value: address
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                    value: Formating.formatPhone(phoneNumber),
                    onChange: (function (value) {
                      Curry._1(setPhoneNumber, (function (param) {
                        return value;
                      }));
                    }),
                    size: "m",
                    label: "Номер телефона"
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Почта",
                    type_: "email",
                    name: "email",
                    size: "m",
                    onChange: (function (value) {
                      Curry._1(setEmail, (function (param) {
                        return value;
                      }));
                    }),
                    value: email
                  })
                ],
                className: "md:grid md:grid-cols-2 items-start gap-4 mt-4"
              }),
              id === "" ? JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                              src: StaticAsset.src("/static/icons/people-gray-20.svg")
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "font-semibold text-asphalt",
                              children: "Данные о сотруднике"
                            })
                          ],
                          className: "flex gap-2"
                        }),
                        JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                          checked: showEmployeeData,
                          onChange: (function (param) {
                            Curry._1(setShowEmployeeData, (function (param) {
                              return !showEmployeeData;
                            }));
                          })
                        })
                      ],
                      className: "flex justify-between"
                    }),
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                              label: "Должность",
                              type_: "text",
                              name: "position",
                              size: "m",
                              required: showEmployeeData,
                              onChange: (function (value) {
                                Curry._1(setPosition, (function (param) {
                                  return value;
                                }));
                              }),
                              value: position
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                              value: jobStartDate,
                              onPicked: (function (date) {
                                Curry._1(setJobStartDate, (function (param) {
                                  return DateTime.toDateFormat(date);
                                }));
                              }),
                              align: "BottomLeft",
                              className: "w-full",
                              label: "Дата начала работы"
                            })
                          ],
                          className: "md:grid md:grid-cols-2 items-start gap-4 mt-4"
                        }),
                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                          className: "text-default-gray mt-6 font-semibold",
                          children: "ТИП СОТРУДНИКА"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                              checked: employmentType === /* EMPLOYMENT_TYPE_SALARY */ 1,
                              onChange: (function (param) {
                                Curry._1(setEmploymentType, (function (param) {
                                  return /* EMPLOYMENT_TYPE_SALARY */ 1;
                                }));
                              }),
                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "ml-1",
                                children: "Трудовой договор"
                              })
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                              checked: employmentType === /* EMPLOYMENT_TYPE_CONTRACT */ 2,
                              onChange: (function (param) {
                                Curry._1(setEmploymentType, (function (param) {
                                  return /* EMPLOYMENT_TYPE_CONTRACT */ 2;
                                }));
                              }),
                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "ml-1",
                                children: "ГПХ"
                              })
                            })
                          ],
                          className: "flex gap-6 mt-4"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                              className: "text-default-gray mt-6 font-semibold",
                              children: "МЕТОД РАСЧЕТА"
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                  className: "mt-4",
                                  checked: paymentTypeOption === "option1",
                                  onChange: (function (param) {
                                    Curry._1(setPaymentTypeOption, (function (param) {
                                      return "option1";
                                    }));
                                  }),
                                  children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                    className: "ml-1",
                                    children: [
                                      "От обратного",
                                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                        className: "text-gray-medium",
                                        children: "Зарплата на руки"
                                      })
                                    ]
                                  })
                                }),
                                JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                  className: "mt-4",
                                  checked: paymentTypeOption === "option2",
                                  onChange: (function (param) {
                                    Curry._1(setPaymentTypeOption, (function (param) {
                                      return "option2";
                                    }));
                                  }),
                                  children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                    className: "ml-1",
                                    children: [
                                      "Прямой расчет",
                                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                        className: "text-gray-medium",
                                        children: "Зарплата с налогами"
                                      })
                                    ]
                                  })
                                })
                              ],
                              className: "flex gap-6"
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                  label: "Зарплата",
                                  type_: "text",
                                  name: "salary",
                                  size: "m",
                                  required: showEmployeeData,
                                  onChange: (function (value) {
                                    const cleanValue = value.replace(/\s/g, "");
                                    Curry._1(setSalary, (function (param) {
                                      return cleanValue;
                                    }));
                                  }),
                                  value: MelNumeral.formatSalary({
                                    NAME: "Str",
                                    VAL: salary
                                  })
                                }),
                                JsxRuntime.jsx("img", {
                                  className: "absolute right-4 top-4 w-5 h-5",
                                  alt: "tenge",
                                  src: StaticAsset.src("/static/icons/tenge.svg")
                                })
                              ],
                              className: Cn.$plus("relative mt-4", Cn.on("hidden", empTypeSelectedOption === "option2"))
                            }),
                            JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                              className: Cn.$plus("text-asphalt mt-1", Cn.on("hidden", empTypeSelectedOption === "option2")),
                              children: [
                                "Минимальная сумма — ",
                                JsxRuntime.jsx("span", {
                                  children: "85 000 ₸",
                                  className: "text-links cursor-pointer",
                                  onClick: (function (param) {
                                    Curry._1(setSalary, (function (param) {
                                      return "85000";
                                    }));
                                  })
                                })
                              ]
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Применить стандартный налоговый вычет"
                                    }),
                                    JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      alt: "info",
                                      src: StaticAsset.src("/static/icons/info.svg")
                                    })
                                  ],
                                  className: "flex gap-2 items-center"
                                }),
                                JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                  checked: isStandardTaxes,
                                  onChange: (function (value) {
                                    Curry._1(setIsStandardTaxes, (function (param) {
                                      return value;
                                    }));
                                  })
                                })
                              ],
                              className: Cn.$plus("flex justify-between items-center mt-6 gap-2", Cn.on("hidden", empTypeSelectedOption === "option2"))
                            }),
                            JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                value: taxesStartDate,
                                onPicked: (function (date) {
                                  Curry._1(setTaxesStartDate, (function (param) {
                                    return DateTime.toDateFormat(date);
                                  }));
                                }),
                                align: "BottomLeft",
                                className: "w-full",
                                label: "Начиная с"
                              }),
                              className: Cn.$plus(Cn.$plus("mt-2", Cn.on("hidden", !isStandardTaxes)), Cn.on("hidden", empTypeSelectedOption === "option2"))
                            })
                          ]
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  children: "Применить льготы"
                                }),
                                JsxRuntime.jsx("img", {
                                  className: "w-5 h-5",
                                  alt: "info",
                                  src: StaticAsset.src("/static/icons/info.svg")
                                })
                              ],
                              className: "flex gap-2 items-center"
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                              checked: isBenefit,
                              onChange: (function (value) {
                                Curry._1(setIsBenefit, (function (param) {
                                  return value;
                                }));
                              })
                            })
                          ],
                          className: "flex justify-between items-center mt-6"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: !resident,
                              onChange: (function (param) {
                                Curry._1(setResident, (function (param) {
                                  return !resident;
                                }));
                              }),
                              text: "Не резидент РК"
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: eResident,
                              onChange: (function (param) {
                                Curry._1(setEResident, (function (param) {
                                  return !eResident;
                                }));
                              }),
                              text: "Резидент ЕврАзЭС",
                              className: Cn.$plus("ml-6", Cn.on("hidden", resident))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                              className: Cn.$plus("ml-6", Cn.on("hidden", resident)),
                              checked: residentPermit === true,
                              onChange: (function (param) {
                                Curry._1(setResidentPermit, (function (param) {
                                  return true;
                                }));
                              }),
                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "ml-1",
                                children: "С видом на жительство РК"
                              })
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                              className: Cn.$plus("ml-6", Cn.on("hidden", resident)),
                              checked: residentPermit === false,
                              onChange: (function (param) {
                                Curry._1(setResidentPermit, (function (param) {
                                  return false;
                                }));
                              }),
                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "ml-1",
                                children: "Без вида на жительство РК"
                              })
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: residentPermit,
                              onChange: (function (param) {
                                Curry._1(setResidentPermit, (function (param) {
                                  return !residentPermit;
                                }));
                              }),
                              text: "Разрешение на работу",
                              className: Cn.$plus("ml-6", Cn.on("hidden", resident))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: isRetired,
                              onChange: (function (param) {
                                Curry._1(setIsRetired, (function (param) {
                                  return !isRetired;
                                }));
                              }),
                              text: "Пенсионер по возрасту",
                              subText: "мужчины — 63, женщины — 61"
                            }),
                            JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                value: retiredStartDate,
                                onPicked: (function (date) {
                                  Curry._1(setRetiredStartDate, (function (param) {
                                    return DateTime.toDateFormat(date);
                                  }));
                                }),
                                align: "BottomLeft",
                                label: "Дата начала льготы"
                              }),
                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isRetired))
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                  isChecked: isRetiredByYearsServed,
                                  onChange: (function (param) {
                                    Curry._1(setIsRetiredByYearsServed, (function (param) {
                                      return !isRetiredByYearsServed;
                                    }));
                                  }),
                                  text: "Пенсионер по выслуге лет"
                                }),
                                JsxRuntime.jsx("img", {
                                  className: "w-5 h-5",
                                  alt: "info",
                                  src: StaticAsset.src("/static/icons/info.svg")
                                })
                              ],
                              className: "flex gap-2 items-center"
                            }),
                            JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                value: retiredStartDate,
                                onPicked: (function (date) {
                                  Curry._1(setRetiredStartDate, (function (param) {
                                    return DateTime.toDateFormat(date);
                                  }));
                                }),
                                align: "BottomLeft",
                                label: "Дата начала льготы"
                              }),
                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetiredByYearsServed))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: isDisabled,
                              onChange: (function (param) {
                                Curry._1(setIsDisabled, (function (param) {
                                  return !isDisabled;
                                }));
                              }),
                              text: "Инвалид I, II, III группы"
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                    value: disabledStartDate,
                                    onPicked: (function (date) {
                                      Curry._1(setDisabledStartDate, (function (param) {
                                        return DateTime.toDateFormat(date);
                                      }));
                                    }),
                                    align: "BottomLeft",
                                    label: "Дата начала льготы"
                                  }),
                                  className: "grow"
                                }),
                                JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                    value: disabledEndDate,
                                    onPicked: (function (date) {
                                      Curry._1(setDisabledEndDate, (function (param) {
                                        return DateTime.toDateFormat(date);
                                      }));
                                    }),
                                    align: "BottomLeft",
                                    label: "Дата окончания"
                                  }),
                                  className: "grow"
                                })
                              ],
                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isDisabled))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: isDisabledIndefinitely,
                              onChange: (function (param) {
                                Curry._1(setIsDisabledIndefinitely, (function (param) {
                                  return !isDisabledIndefinitely;
                                }));
                              }),
                              text: "Инвалид I, II группы бессрочно"
                            }),
                            JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                value: match$33[0],
                                onPicked: (function (date) {
                                  Curry._1(setBenefitStartDate, (function (param) {
                                    return DateTime.toDateFormat(date);
                                  }));
                                }),
                                align: "BottomLeft",
                                label: "Дата начала льготы"
                              }),
                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isDisabledIndefinitely))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: isParent,
                              onChange: (function (param) {
                                Curry._1(setIsParent, (function (param) {
                                  return !isParent;
                                }));
                              }),
                              text: "Родитель/опекун инвалида"
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                  value: match$36[0],
                                  onPicked: (function (date) {
                                    Curry._1(setParentStartDate, (function (param) {
                                      return DateTime.toDateFormat(date);
                                    }));
                                  }),
                                  align: "BottomLeft",
                                  className: "md:w-[209px]",
                                  label: "Дата начала льгот"
                                }),
                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                  label: "Количество детей",
                                  type_: "text",
                                  name: "name",
                                  size: "m",
                                  required: true,
                                  onChange: (function (value) {
                                    Curry._1(setChildren, (function (param) {
                                      try {
                                        return Caml_format.caml_int_of_string(value);
                                      }
                                      catch (exn){
                                        return 0;
                                      }
                                    }));
                                  }),
                                  className: "md:w-[209px]",
                                  value: String(children)
                                })
                              ],
                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isParent))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: isMother,
                              onChange: (function (param) {
                                Curry._1(setIsMother, (function (param) {
                                  return !isMother;
                                }));
                              }),
                              text: "Многодетная мать",
                              subText: "4 и более детей"
                            }),
                            JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                value: motherBenefitStartDate,
                                onPicked: (function (date) {
                                  Curry._1(setMotherBenefitStartDate, (function (param) {
                                    return DateTime.toDateFormat(date);
                                  }));
                                }),
                                align: "BottomLeft",
                                label: "Дата начала льготы"
                              }),
                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isMother))
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                              isChecked: isStudent,
                              onChange: (function (param) {
                                Curry._1(setIsStudent, (function (param) {
                                  return !isStudent;
                                }));
                              }),
                              text: "Студент"
                            }),
                            JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                    value: studentBenefitStartDate,
                                    onPicked: (function (date) {
                                      Curry._1(setStudentBenefitStartDate, (function (param) {
                                        return DateTime.toDateFormat(date);
                                      }));
                                    }),
                                    align: "BottomLeft",
                                    label: "Начало обучения"
                                  }),
                                  className: "grow"
                                }),
                                JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                    value: studentBenefitEndDate,
                                    onPicked: (function (date) {
                                      Curry._1(setStudentBenefitEndDate, (function (param) {
                                        return DateTime.toDateFormat(date);
                                      }));
                                    }),
                                    align: "BottomLeft",
                                    label: "Дата окончания"
                                  }),
                                  className: "grow"
                                })
                              ],
                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isStudent))
                            })
                          ],
                          className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
                        })
                      ],
                      className: Cn.$plus("", Cn.on("hidden", !showEmployeeData))
                    })
                  ],
                  className: "py-[10px] mt-6 px-4 border border-gray-main rounded"
                }) : null
            ],
            className: "px-6 py-10 md:p-10"
          }),
          className: "bg-white min-w-[343px] md:w-[562px] rounded-md"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
            title: "Сохранить",
            className: "px-6 py-3",
            type_: "submit"
          }),
          className: "w-full md:w-[562px] flex justify-end mt-9"
        })
      ],
      onSubmit: (function (ev) {
        if (id === "") {
          ev.preventDefault();
          const retiredBenefit = Curry._4(Buhta_cabinet__TaxControl.PersonCategoryBenefit.make, /* PERSON_CATEGORY_PENSIONER_AGE */ 1, retiredStartDate !== "" ? Buhta_cabinet__Date.fromString(retiredStartDate) : undefined, undefined, undefined);
          const retiredDutyBenefit = Curry._4(Buhta_cabinet__TaxControl.PersonCategoryBenefit.make, /* PERSON_CATEGORY_PENSIONER_DUTY */ 2, retiredDutyStartDate !== "" ? Buhta_cabinet__Date.fromString(retiredDutyStartDate) : undefined, undefined, undefined);
          const disabledBenefit = Curry._4(Buhta_cabinet__TaxControl.PersonCategoryBenefit.make, disabledCategory$1, disabledStartDate !== "" ? Buhta_cabinet__Date.fromString(disabledStartDate) : undefined, {
            NAME: "Disabled",
            VAL: {
              end_date: disabledEndDate !== "" ? Buhta_cabinet__Date.fromString(disabledEndDate) : undefined
            }
          }, undefined);
          const disabledIndefinitelyBenefit_begin_date = disabledIndefinitelyStartDate !== "" ? Buhta_cabinet__Date.fromString(disabledIndefinitelyStartDate) : undefined;
          const disabledIndefinitelyBenefit_benefit = {
            NAME: "Disabled_permanent",
            VAL: undefined
          };
          const disabledIndefinitelyBenefit = {
            category: disabled_category_permanent,
            begin_date: disabledIndefinitelyBenefit_begin_date,
            benefit: disabledIndefinitelyBenefit_benefit
          };
          const parentBenefit_begin_date = parentBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(parentBenefitStartDate) : undefined;
          const parentBenefit_benefit = {
            NAME: "Guardian_disabled",
            VAL: {
              children: children > 0 ? children : undefined
            }
          };
          const parentBenefit = {
            category: /* PERSON_CATEGORY_GUARDIAN_DISABLED */ 9,
            begin_date: parentBenefit_begin_date,
            benefit: parentBenefit_benefit
          };
          const motherBenefit_begin_date = motherBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(motherBenefitStartDate) : undefined;
          const motherBenefit_benefit = {
            NAME: "Mother_many",
            VAL: undefined
          };
          const motherBenefit = {
            category: /* PERSON_CATEGORY_MOTHER_MANY */ 15,
            begin_date: motherBenefit_begin_date,
            benefit: motherBenefit_benefit
          };
          const studentBenefit_begin_date = studentBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(studentBenefitStartDate) : undefined;
          const studentBenefit_benefit = {
            NAME: "Student",
            VAL: {
              end_date: studentBenefitEndDate !== "" ? Buhta_cabinet__Date.fromString(studentBenefitEndDate) : undefined
            }
          };
          const studentBenefit = {
            category: /* PERSON_CATEGORY_STUDENT */ 16,
            begin_date: studentBenefit_begin_date,
            benefit: studentBenefit_benefit
          };
          const taxDeductionBenefits_begin_date = taxesStartDate !== "" ? Buhta_cabinet__Date.fromString(taxesStartDate) : undefined;
          const taxDeductionBenefits = {
            "type'": /* TAX_DEDUCTION_TYPE_14_MRP */ 3,
            begin_date: taxDeductionBenefits_begin_date,
            end_date: undefined
          };
          const categoryBenefits = Stdlib.$at(/* [] */ 0, Stdlib.$at(isRetired ? ({
              hd: retiredBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0, Stdlib.$at(isRetiredByYearsServed ? ({
              hd: retiredDutyBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0, Stdlib.$at(isDisabled ? ({
              hd: disabledBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0, Stdlib.$at(isDisabledIndefinitely ? ({
              hd: disabledIndefinitelyBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0, Stdlib.$at(isParent ? ({
              hd: parentBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0, Stdlib.$at(isMother ? ({
              hd: motherBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0, isStudent ? ({
              hd: studentBenefit,
              tl: /* [] */ 0
            }) : /* [] */ 0)))))));
          const taxDeductionBenefits$1 = Stdlib.$at(/* [] */ 0, isStandardTaxes ? ({
              hd: taxDeductionBenefits,
              tl: /* [] */ 0
            }) : /* [] */ 0);
          const cleanFormattedSalary = function (formattedSalary) {
            return formattedSalary.replace(/\u2009/g, "");
          };
          const salaryValue = salary !== "" ? cleanFormattedSalary(salary) : undefined;
          const employment_event_date = jobStartDate !== "" ? Buhta_cabinet__Date.fromString(jobStartDate) : undefined;
          const employment_info = {
            resident: resident,
            eaeu_resident: eResident,
            has_residence_permit: residentPermit,
            employment_type: employmentType,
            position: position,
            tax_deduction_benefits: taxDeductionBenefits$1,
            category_benefits: categoryBenefits,
            salary_rate: salaryValue,
            mzp_salary: salary === "85000",
            effective_salary_rate: undefined,
            gross_method: grossMethod
          };
          const employment = {
            event_type: /* EMPLOYMENT_EVENT_TYPE_START */ 1,
            event_date: employment_event_date,
            info: employment_info
          };
          const form_birthday_date = birthday !== "" ? Buhta_cabinet__Date.fromString(birthday) : undefined;
          const form_address = address;
          const form_email = email;
          const form_employment = showEmployeeData ? employment : undefined;
          const form = {
            tin: iin,
            family_name: lastname,
            given_name: name,
            patronymic_name: patronymicName,
            birthday_date: form_birthday_date,
            address: form_address,
            email: form_email,
            phone: phoneNumber,
            employment: form_employment
          };
          const __x = Buhta_cabinet__PayrollHrm.EmployeeService.create(tenant, form);
          return $$Promise.get(__x, (function (result) {
            if (result.TAG === /* Ok */ 0) {
              Buhta_cabinet__Route.navigateTo(contextRoute({
                TAG: /* Hrm */ 5,
                _0: {
                  TAG: /* Employees */ 0,
                  _0: /* Index */ 0
                }
              }));
              return Curry._1(dispatchToasts, {
                TAG: /* Add */ 0,
                _0: {
                  id: Buhta_core__Toast.generateId(undefined),
                  text: "Сотрудник успешно создан",
                  kind: "success",
                  onClick: (function (param) {
                    
                  })
                }
              });
            }
            const err = result._0;
            console.log("err", err);
            Buhta_cabinet__ToastSender.sendHrmEmployee(dispatchToasts, err, "Ошибка при создании сотрудника: ");
          }));
        } else {
          ev.preventDefault();
          const form_birthday_date$1 = birthday !== "" ? Buhta_cabinet__Date.fromString(birthday) : undefined;
          const form_address$1 = address;
          const form_email$1 = email;
          const form$1 = {
            tin: iin,
            family_name: lastname,
            given_name: name,
            patronymic_name: patronymicName,
            birthday_date: form_birthday_date$1,
            address: form_address$1,
            email: form_email$1,
            phone: phoneNumber,
            employment: undefined
          };
          const __x$1 = Buhta_cabinet__PayrollHrm.EmployeeService.update(tenant, id, form$1);
          return $$Promise.get(__x$1, (function (result) {
            if (result.TAG === /* Ok */ 0) {
              Buhta_cabinet__Route.navigateTo(contextRoute({
                TAG: /* Hrm */ 5,
                _0: {
                  TAG: /* Employees */ 0,
                  _0: /* Index */ 0
                }
              }));
              return Curry._1(dispatchToasts, {
                TAG: /* Add */ 0,
                _0: {
                  id: Buhta_core__Toast.generateId(undefined),
                  text: "Сотрудник успешно изменен",
                  kind: "success",
                  onClick: (function (param) {
                    
                  })
                }
              });
            }
            const err = result._0;
            console.log("err", err);
            Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, err, "Ошибка при создании сотрудника");
          }));
        }
      })
    }),
    className: "bg-gray-pale px-4 py-6 md:py-10 md:px-0 flex-col items-center"
  });
}

const make = HrmEmployeeFormPage;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
